"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _rendererCore = require("@quillforms/renderer-core");
var _data = require("@wordpress/data");
var _tinycolor = _interopRequireDefault(require("tinycolor2"));
var _emotion = require("emotion");
var _classnames = _interopRequireDefault(require("classnames"));
var EmailValidator = _interopRequireWildcard(require("email-validator"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * QuillForms Dependencies
 */

/**
 * WordPress Dependencies
 */

/**
 * External Dependencies
 */

const EmailOutput = props => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    setValidationErr,
    showNextBtn,
    val,
    setVal,
    showErrMsg,
    next,
    inputRef,
    isTouchScreen,
    setFooterDisplay,
    isPreview,
    isReviewing
  } = props;
  const theme = (0, _rendererCore.useBlockTheme)(attributes.themeId);
  const messages = (0, _rendererCore.useMessages)();
  const answersColor = (0, _tinycolor.default)(theme.answersColor);
  const {
    required,
    placeholder
  } = attributes;
  const checkFieldValidation = value => {
    if (required === true && (!value || value === '' || value.length === 0)) {
      setIsValid(false);
      setValidationErr(messages['label.errorAlert.required']);
    } else if (value && !EmailValidator.validate(value) && value.length > 0) {
      setIsValid(false);
      setValidationErr(messages['label.errorAlert.email']);
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };
  (0, _react.useEffect)(() => {
    if (isPreview || !isReviewing) checkFieldValidation(val);
  }, [required]);
  const changeHandler = e => {
    const value = e.target.value;
    checkFieldValidation(value);
    setVal(value);
    showErrMsg(false);
    if (!value) {
      setIsAnswered(false);
    } else {
      setIsAnswered(true);
      showNextBtn(true);
    }
  };
  return (0, _react.createElement)("input", {
    ref: inputRef,
    className: (0, _classnames.default)((0, _emotion.css)`
					& {
						width: 100%;
						border: none !important;
						outline: none;
						padding-bottom: 8px !important;
						padding-left: 0 !important;
						padding-right: 0 !important;
						border-radius: 0 !important;
						background: transparent;
						background-color: transparent !important;
						transition: box-shadow 0.1s ease-out 0s;
						-webkit-appearance: none;
						box-shadow: ${answersColor.setAlpha(0.3).toString()}
							0px 1px !important;
					}

					&::placeholder {
						opacity: 0.3;
						/* Chrome, Firefox, Opera, Safari 10.1+ */
						color: ${theme.answersColor};
					}

					&:-ms-input-placeholder {
						opacity: 0.3;
						/* Internet Explorer 10-11 */
						color: ${theme.answersColor};
					}

					&::-ms-input-placeholder {
						opacity: 0.3;
						/* Microsoft Edge */
						color: ${theme.answersColor};
					}

					&:focus {
						box-shadow: ${answersColor.setAlpha(1).toString()}
							0px 2px !important;
						border: none !important;
						outline: none !important;
					}

					color: ${theme.answersColor} !important;
				`),
    id: 'email-' + id,
    type: "email",
    placeholder: placeholder === false ? messages['block.email.placeholder'] : placeholder,
    onChange: changeHandler,
    value: val && val.length > 0 ? val : '',
    onFocus: () => {
      if (isTouchScreen) {
        setFooterDisplay(false);
      }
    },
    onBlur: () => {
      if (isTouchScreen) {
        setFooterDisplay(true);
      }
    },
    autoComplete: "off"
  });
};
var _default = exports.default = EmailOutput;
//# sourceMappingURL=display.js.map